import { render, staticRenderFns } from "./PathwayMetadata.vue?vue&type=template&id=4279d39c&"
import script from "./PathwayMetadata.vue?vue&type=script&lang=js&"
export * from "./PathwayMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports